import t from "./td-longtail-vue-components235.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var r = function() {
  var e = this, a = e._self._c, l = e._self._setupProxy;
  return a("span", [e._t("trigger", null, { open: l.openDialog }), a(l.BaseDialog, { ref: "baseDialog", class: ["modal", e.customClass, { "modal--no-max-width": e.noMaxWidth }], attrs: { "is-modal": "", "heading-text": e.headingText, "aria-label": e.ariaLabel, "close-on-backdrop": e.closeOnBackdrop, "disable-focus-trap": e.disableFocusTrap, "data-tealium-rel": e.dataTealiumRel, "close-autofocus": e.closeAutofocus }, on: { onCloseModal: () => e.$emit("onCloseModal") }, scopedSlots: e._u([{ key: "header", fn: function({ close: o }) {
    return [e._t("header", null, { close: o })];
  } }, { key: "default", fn: function({ close: o }) {
    return [e._t("default", null, { close: o })];
  } }, { key: "footer", fn: function({ close: o }) {
    return [e._t("footer", null, { close: o })];
  } }], null, !0) })], 2);
}, s = [], u = /* @__PURE__ */ n(
  t,
  r,
  s,
  !1,
  null,
  "072bdb67"
);
const _ = u.exports;
export {
  _ as default
};
